import { HttpClientOptions } from "./interfaces/HttpClientOptions";

export class BaseHttpResource {
  /**
   * @constructor
   * @param {string} baseUrl
   * @param {HttpClient} httpClient
   * @param defaultOptions
   */
  constructor(private baseUrl,
              private httpClient,
              private defaultOptions: HttpClientOptions = {}) {
  }

  /**
   * @public
   * @param url
   * @param body
   * @param options
   * @returns {*}
   */
  post(url, body, options) {
    const { requestUrl, requestOptions } = this.resolveRequestData(url, options);
    return this.httpClient.post(requestUrl, body, requestOptions);
  }

  put(url, body, options) {
    const { requestUrl, requestOptions } = this.resolveRequestData(url, options);
    return this.httpClient.put(requestUrl, body, requestOptions);
  }

  patch(url, body, options) {
    const { requestUrl, requestOptions } = this.resolveRequestData(url, options);
    return this.httpClient.patch(requestUrl, body, requestOptions);
  }

  get(url, body, options) {
    const { requestUrl, requestOptions } = this.resolveRequestData(url, options);
    const getRequestOptions = Object.assign({}, { params: body }, requestOptions);
    return this.httpClient.get(requestUrl, getRequestOptions);
  }

  delete(url, options) {
    const { requestUrl, requestOptions } = this.resolveRequestData(url, options);
    return this.httpClient.delete(requestUrl, requestOptions);
  }

  setHeaders(headers) {
    this.defaultOptions.headers = Object.assign({}, this.defaultOptions.headers, headers);
  }

  clearHeaders() {
    delete this.defaultOptions.headers;
  }

  /**
   * @private
   * @param url
   * @param options
   * @returns {{requestUrl, requestOptions: *}}
   */
  resolveRequestData(url, options) {
    const requestUrl = this.resolveRequestUrl(url);
    const requestOptions = this.resolveRequestOptions(options);
    return { requestUrl, requestOptions };
  }

  /**
   * @private
   * @param url
   * @returns {string}
   */
  resolveRequestUrl(url) {
    const urlPart = `/${url}`;
    return this.baseUrl + urlPart.replace('//', '/');

    // todo реализовать по уму
    // let result = this.baseUrl + urlPart.replace('//', '/');
    // if (this.defaultOptions.timeOffset) {
    //   const timeOffset = (new Date()).getTimezoneOffset() * -1;
    //   result += `?time_offset=${timeOffset}`;
    // }
    // return result;
  }

  /**
   * @private
   * @param options
   * @returns {*}
   */
  resolveRequestOptions(options) {
    return Object.assign({}, this.defaultOptions, options);
  }

}
